var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isOnline)?_c('div',{staticClass:"offline-bar"},[_c('i',{staticClass:"icon-offline"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('offlineBar.content')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }